import React, { memo } from "react";
// import config
import theme from "../config/theme";

const Input = ({ type, name, value, errors, touched, mode = 'dark', ...rest }) => {
    const className = mode == 'dark'
        ? `w-full pl-10 pr-4 py-2 border border-cyan-500/30 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-cyan-500 focus:border ${(touched && touched[name] && errors && errors[name]) ? 'border-red-500' : ''}`
        : `w-full pl-10 pr-10 py-3 bg-transparent border border-gray-300 rounded-lg text-gray-800 placeholder-gray-500 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors ${(touched && touched[name] && errors && errors[name]) ? 'border-red-300' : 'border-gray-300'}`

    return (
        <input
            type={type}
            name={name}
            value={value}
            style={mode == 'dark' ? { background: theme?.colors?.bg?.primary } : { background: theme?.colors?.text?.primary }}
            className={className}
            {...rest}
        />
    )
}

export default memo(Input);